<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <alert></alert> <!-- rederizando componente alert -->


                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                    <thead>
                        <tr role="row">
                            <th>Data</th>
                            <th>Tipo</th>
                            <th>Cpf/Cnpj</th>
                            <th>Usuário</th>
                            <th>Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="even" role="row" v-for="item in apiData.data">
                            <td>{{ date_format(item.created_at) }}</td>
                            <td>{{ item.tipo }}</td>
                            <td>{{ item.cpf_cnpj }}</td>
                            <td>{{ item.usuario.name }}</td>
                            <td>
                                <a title='Visualizar' href="javascript:void(0)" @click="visualizar(item.id, item.tipo)"><i class="fa fa-fw fa-eye"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="row">
                    <div class='col-sm-5'>
                        Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.
                    </div>
                    <div class='col-sm-7' style="text-align:right">
                        <laravue-pagination :data="apiData" v-on:pagination-change-page="getHistorico">
                            <span slot="prev-nav">&lt; Anterior</span>
                            <span slot="next-nav">Próximo &gt;</span>
                        </laravue-pagination>
                    </div>
                </div>

            </div> <!-- /.col-md-12 -->
        </div> <!-- /.row -->

        <div v-if="loading" class="row">
            <div class="col-sm-12">                             
                <div style="text-align: center">
                    <img src="" />
                    <span>Aguarde, processando...</span>
                </div>
            </div>
        </div>
        <div>
            <resultado-restritiva v-if="resultadoRestritiva != '' && !loading" :resultado='resultadoRestritiva'></resultado-restritiva>
            <resultado-analitica v-if="resultadoAnalitica != '' && !loading" :resultado='resultadoAnalitica'></resultado-analitica>
        </div>
    </section>
</template>
<script>
    import axios from 'axios' // Cliente para requisição http
    import Alert from '../Alert' // Importando componente alert 
    import ResultadoAnalitica from './ResultadoAnalitica'
    import ResultadoRestritiva from './ResultadoRestritiva'

    export default {
       components: {
        Alert,
        ResultadoAnalitica,
        ResultadoRestritiva
    },
    data: () => ({
        filtro: '',
        apiData: {},
        resultadoAnalitica: '',
        resultadoRestritiva: '',
        loading: false,

    }),
    mounted () {
        this.getHistorico()
    },

    methods: {
        visualizar(id, tipo) {

           this.loading = true;
           axios.get(`${this.$store.state.serverURI}/api/consulta/getById/${id}`, this.$store.getters.getHeaderAuth)
           .then(response => {
            if (tipo == 'RESTRITIVA') {
                this.resultadoAnalitica = '';
                this.resultadoRestritiva = response.data;
            } else if (tipo == 'ANALÍTICA') {
                this.resultadoRestritiva = '';
                this.resultadoAnalitica = response.data;
            }
            
            this.loading = false;
        }).catch((error) => { this.$store.commit('throwException', error); });
       },

       getHistorico(page) {
        if (typeof page === 'undefined') {
            page = 1;
        }
        this.$store.commit('TOGGLE_LOADING');
        axios.get(`${this.$store.state.serverURI}/api/consulta/getAllPaginate` + ((this.filtro) ? '/' + this.filtro : '') + '/?page=' + page, this.$store.getters.getHeaderAuth)
        .then(response => {
            this.apiData = response.data;
            this.$store.commit('TOGGLE_LOADING');
        }).catch((error) => { this.$store.commit('throwException', error); });
    },

    date_format(param) {
      var data = param.split('-');

      var arr = data[2].split(' ');
      if (typeof arr[1] === 'undefined') {
        return arr[0]+'/'+data[1]+'/'+data[0];
    }
    return arr[0]+'/'+data[1]+'/'+data[0]+' '+arr[1];

},
},
watch: {
    page: function (val) {
        this.getHistorico();
    }
},

}
</script>
<style>
    .box.box-solid>.box-header .btn.btn-default {
        background-color: #f4f4f4;
        color: #444;
        border-color: #ddd;
    }

    .box.box-solid>.box-header .btn.btn-default:hover {
     color: #333;
     background-color: #d4d4d4;
     border-color: #8c8c8c;
 }


</style>


// WEBPACK FOOTER //
// Historico.vue?07ed28ca